/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var esUtils = require('ES/utils/esUtils');
var FormMixin = require('ES/widgets/forms/FormMixin');
var RadioMixin = require('ES/utils/RadioMixin');
var ErrorAlert = require('ES/widgets/ErrorAlert');
var LoadingWrap = require('ES/widgets/LoadingWrap');
var SlideOpenDown = require('../../widgets/SlideOpenDown');
var VerticalFields = require('ES/widgets/VerticalFields');
var AuthedUserSession = require('../../../utils/AuthedUserSession');

module.exports = dd.createClass({
  mixins: [RadioMixin],
  getInitialState: function () {
    return {saving: false, error_msg: null};
  },
  componentWillMount: function () {
    var self = this;
    self.radio = {
      save_UserPreferences: function () {
        self.setState({saving: true, error_msg: null});
      },
      save_UserPreferences_succeeded: function () {
        self.setState({saving: false, error_msg: null});
      },
      save_UserPreferences_failed: function (message) {
        self.setState({saving: false, error_msg: 'Failed to save your preferences: ' + message});
      }
    };
  },
  __onSubmit: function (data) {
    radio('save_UserPreferences').broadcast(data);
  },
  render: function () {
    const Displaylists = this.props.Displaylists;

    return LoadingWrap({is_loading: _.isEmpty(Displaylists) || this.state.saving, glass: true},
      dd.div({className: 'Preferences'},
        dd.h2({style: {marginTop: 0}}, 'Preferences'),
        dd.p({style: {marginBottom: 40}},
          'These preferences only affect your login: ' + AuthedUserSession.MY_USERNAME
        ),
        ErrorAlert({message: this.state.error_msg}),
        DaForm({Displaylists: Displaylists, onSubmit: this.__onSubmit})
      )
    );
  }
});

var DaForm = dd.createClass({
  mixins: [FormMixin],
  getInitialValuesSourceVersion: function (props) {
    return AuthedUserSession.MY_USERNAME + JSON.stringify(_.get(props, "Displaylists.user.myevents_preferences"));
  },
  getInitialValues: function (props) {
    return _.get(props, "Displaylists.user.myevents_preferences");
  },
  buildFields: function () {
    //NOTE
    //NOTE don't willy-nilly change these keys or option keys. These are what are saved in the db and used to reference their preferences.
    //NOTE
    //NOTE adding a new pref here: also add to AuthenticateController::$DEFAULT_MYEVENTS_USER_PREFERENCES
    //NOTE
    let r = {
      notify_coworkers_on_schedule_changes: {
        label: 'Notify co-workers on schedule changes',
        type: 'checkbox'
      },
      ask_for_reason_when_canceling_or_releasing: {
        label: 'Ask for a reason when canceling/releasing',
        type: 'checkbox'
      },
      hide_personal_days_on_dashboard_lists: {
        label: 'Hide personal/blackout days on dashboard lists',
        type: 'checkbox'
      },
      open_crm_in_same_window: {
        label: 'Open CRM in same window instead of opening a new one',
        type: 'checkbox'
      },
      show_other_companies_by_default: {
        label: 'Check the "show other companies" checkbox on startup',
        type: 'checkbox'
      },
      show_parent_child_ui: {
        label: 'ADVANCED: enable parent-child event relationships',
        type: 'checkbox'
      },
      hide_closed_events_in_results: {
        label: 'Default to hiding Closed events in search results',
        type: 'checkbox',
      },
      sort_results: {
        label: 'Order dashboard lists and search results',
        type: 'select',
        options: {
          earliest_at_bottom: 'Earliest date at bottom',
          earliest_at_top: 'Earliest date at top'
        }
      },
      library_placeholder_codes_if_field_is_empty: {
        label: 'Document Library placeholder codes -- If the replacement field is empty',
        type: 'select',//'radio',
        options: {
          leave_placeholder: 'leave the placeholder in the result document',
          leave_empty: 'leave the empty space'
        }
      }
    };

    if (AuthedUserSession.is_privatelabel) {
      delete r["show_parent_child_ui"];
    } else {
      delete r["show_other_companies_by_default"];
      delete r["hide_closed_events_in_results"];
    }

    return r;

  },
  __discardChanges: esUtils.wrapPreventDefault(function () {
    this._form_reset();
  }),
  render: function () {
    const fields = this.buildFields();
    const errors = this.state.errors || {};
    const changes_made = this._form_areChangesMade();

    return dd.form({className: '', onSubmit: this._form_onSubmit},
      dd.div({className: 'row'},
        dd.div({className: 'col-sm-2'}),
        dd.div({className: 'col-sm-8'},
          VerticalFields({
            fields: fields,
            errors: errors,
            buildInput: this._form_buildInput
          }),
          SlideOpenDown({open: changes_made},
            VerticalFields.FormButtons({onDiscard: this.__discardChanges})
          )
        ),
        dd.div({className: 'col-sm-2'})
      )
    );
  }
});


// WEBPACK FOOTER //
// ./src/components/account_settings/preferences/index.js